import { render, staticRenderFns } from "./RealtimeSystem.vue?vue&type=template&id=19c89468&"
import script from "./RealtimeSystem.vue?vue&type=script&lang=js&"
export * from "./RealtimeSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports